import axios from "axios";
import ApplicationRequest from "api/model/ApplicationRequest";

export const applyPopup = (popupId: number, request: ApplicationRequest) => axios.post(`/api/applications/popup/${popupId}`, request).then(res => res.data);

export const applyEvent = (eventId: number, request: ApplicationRequest) => axios.post(`/api/applications/event/${eventId}`, request).then(res => res.data);
